(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click',function(event){const openButton=event.target.closest('[data-product-quote-open]');if(openButton)openButton.parentElement.querySelector('[data-product-quote-dialog]').showModal();const closeButton=event.target.closest('[data-product-quote-close]');if(closeButton)closeButton.closest('[data-product-quote-dialog]').close();if(event.target.matches('[data-product-quote-dialog]'))event.target.close();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uvdtf-global-quote"]) return;
  try {
    document.addEventListener('click',function(event){const opener=event.target.closest('a[href="#UVDTFGlobalQuote"]');if(opener){event.preventDefault();document.getElementById('UVDTFGlobalQuote').showModal()}if(event.target.closest('[data-gq-close]'))document.getElementById('UVDTFGlobalQuote').close();if(event.target.id==='UVDTFGlobalQuote')event.target.close()});
  } catch(e) { console.error(e); }
})();
})();
